import { render } from "./BoxingDetail.vue?vue&type=template&id=2fa18f36&scoped=true"
import script from "./BoxingDetail.vue?vue&type=script&lang=js"
export * from "./BoxingDetail.vue?vue&type=script&lang=js"

import "./BoxingDetail.vue?vue&type=style&index=0&id=2fa18f36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa18f36"]])

export default __exports__